import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const BUSINESS = {
  name: "Oxford Cleaners",
  tagline: "Veteran & Family-Owned",
  address: "5865 W Ray Rd #3, Chandler, AZ 85226",
  phone: "480-940-6023",
  phoneTel: "+14809406023",
  email: "oxfordcleaners.pickup.delivery@gmail.com",
  hours: [
    { label: "Mon – Fri", value: "7:00 AM – 5:00 PM" },
    { label: "Saturday", value: "10:00 AM – 2:00 PM" },
    { label: "Sunday", value: "Closed" },
  ],
  serviceAreas: ["Chandler", "Maricopa", "Ahwatukee", "Tempe", "Gilbert"],
  socials: {
    // Empty strings hide the icon. Update with real URLs (e.g. "https://facebook.com/...").
    facebook: "https://www.facebook.com/profile.php?id=61589268029945",
    instagram: "https://www.instagram.com/oxfordcleanersaz2026/",
    google: "",
  },
  // paymentUrl is also exposed via /api/business-info; mirrored here so the Header
  // can render the button without waiting on a network round-trip on first paint.
  paymentUrl: process.env.REACT_APP_PAYMENT_URL || "",
};
